"use strict";
import Splide from "@splidejs/splide";
const initMagazineSingleSplide = () => {
  const magazineSingleSplideOptions = {
    mediaQuery: "min",
    perMove: 1,
    perPage: 1,
    autoplay: false,
    drag: true,
    speed: 1000,
    clones: 0,
    snap: true,
    arrowPath: "m20 40-3.441-3.5 14.1-14.069H0v-4.857h30.662l-14.1-14.1L20.003.006l20 20z",
    padding: { right: "20em" },
    gap: "4em",
    breakpoints: {
      960: {
        perPage: 3,
      },
    },
  };

  const magazineSingleSplide = new Splide(".magazine-relations__list", magazineSingleSplideOptions);
  magazineSingleSplide.mount();
};

window.addEventListener("DOMContentLoaded", () => {
  initMagazineSingleSplide();
});
